var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-inner"},[_c('div',{staticClass:"pc-body"},[_c('PC')],1),_c('div',{staticClass:"mobile-body"},[_c('Mobile')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }